export default {
  table: {
    name: "名称",
    code: "编码",
    phone: "电话",
    email: "电子邮箱",
    first_name: "名字",
    last_name: "姓氏",
    mobile_number: "手机号码：",
    city: "城市",
    country: "国家",
    address: "地址",
    mobile: "手机",
    state: "省份",
    country_code: "国家代码",
    company_code: "公司编码",
    company_name: "公司名称",
    app_id: "应用程序ID",
    city_zone: "城市区域",
    area_code: "区域编码",
    time_zone: "时区",
  },

  table_product: {
    product_name: "产品名称",
  },

  table_approval: {
    title: "审批流程",
    add: "添加审批流程",
    edit: "编辑审批流程",
    person: "审批人员",
    create_time: "创建时间",
    note: "备注：",
  },
};
